import React from "react";
import StorefrontLayout from "./Layout";
import Breadcrumbs, { breadcrumbJsonLd } from "./Breadcrumbs";
import { useSeo } from "../../lib/seo";

/**
 * Shared layout for all policy / legal pages. Matches the storefront's
 * typography, spacing and dark/light theming, and wires SEO (unique title,
 * meta description, canonical, breadcrumb JSON-LD).
 */
export default function PolicyLayout({ title, heading, description, canonicalPath, updated, testid, children }) {
  const crumbs = [{ label: "Home", to: "/" }, { label: heading }];
  useSeo({
    title,
    description,
    canonicalPath,
    jsonLd: { breadcrumb: breadcrumbJsonLd(crumbs) },
  });

  return (
    <StorefrontLayout>
      <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 md:py-24" data-testid={testid}>
        <Breadcrumbs items={crumbs} />
        <div className="text-[10px] uppercase tracking-[0.3em] text-red-500 font-bold mb-3">Policies</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-medium mb-4" data-testid="policy-heading">
          {heading}
        </h1>
        {updated && <p className="text-xs text-zinc-500 mb-12">Last updated: {updated}</p>}
        <div className="space-y-10">{children}</div>
        <div className="mt-16 pt-8 border-t border-white/10 text-sm text-zinc-500">
          Questions about this policy? Email{" "}
          <a href="mailto:support@lecisautoglass.com" className="text-red-500 hover:text-red-400 transition">
            support@lecisautoglass.com
          </a>
          .
        </div>
      </div>
    </StorefrontLayout>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      {title && (
        <h2 className="font-display text-xl md:text-2xl tracking-tight font-medium text-zinc-100 mb-3">{title}</h2>
      )}
      <div className="space-y-3 text-sm md:text-base text-zinc-400 leading-relaxed">{children}</div>
    </section>
  );
}

export function PolicyList({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-2 text-sm md:text-base text-zinc-400 leading-relaxed">
      {items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}
